import React from 'react';
import { useSelector } from 'react-redux';
import { Route } from 'react-router-dom';

import { AppState } from '../../../store';
import config from '../../../config';

import DocumentCreate from '../screens/create';
import DocumentList from '../screens/list';
import DocumentDetail from '../screens/detail';
import NotFound from '../../not-found/';

const Routes: React.FC = () => {
  const authType: string = useSelector((state: AppState) => state.Authorization.authType);
  const publicUrl = process.env.PUBLIC_URL;

  if(authType) {
    return (
      <>
        <Route path={`${publicUrl}/document/create`} exact component={DocumentCreate} />
        <Route path={`${publicUrl}/document/:providerId/create`} exact component={authType === config.userTypeAdmin ? DocumentCreate : NotFound } />
        <Route path={`${publicUrl}/document/edit/:id`} exact component={DocumentCreate} />
        <Route path={`${publicUrl}/document/:providerId/edit/:id`} exact component={authType === config.userTypeAdmin ? DocumentCreate : NotFound } />
        <Route path={`${publicUrl}/document/list`} exact component={DocumentList} />
        <Route path={`${publicUrl}/document/:providerId/list`} exact component={authType === config.userTypeAdmin ? DocumentList : NotFound } />
        <Route path={`${publicUrl}/document/detail/:id`} exact component={DocumentDetail} />
        <Route path={`${publicUrl}/document/:providerId/detail/:id`} exact component={authType === config.userTypeAdmin ? DocumentDetail : NotFound } />
      </>
    )
  } else {
    return null;
  }
}

export default Routes;